import 'css-chunksrc/client/common/constraintTypeForm/constraintTypeSelect/styles.scss';export default {
  "input": "_input_t5wp7_1",
  "opened": "_opened_t5wp7_14",
  "icon": "_icon_t5wp7_20",
  "listRoot": "_listRoot_t5wp7_28",
  "list": "_list_t5wp7_28",
  "type": "_type_t5wp7_40",
  "selected": "_selected_t5wp7_49",
  "name": "_name_t5wp7_52"
};